import axios from 'axios'

import APIs from '../../api'
import { apiClient } from '../../api/client'
import { PLATFORM } from '../../constants'

// Auth — login via global authentication endpoint.
export const loginApi = (payload) => apiClient.post(APIs.AUTH.login, payload)

// Change password (uses Bearer accessToken attached by apiClient interceptor).
// `platform: 'MDG_GUARDIAN'` is hardcoded on this endpoint — the backend
// rejects the request without it. It does NOT go through the interceptor
// because the apiClient skips the `Platform` header when no branch is
// selected (e.g. during the forced /reset-password flow).
export const changePasswordApi = (payload) =>
  apiClient.put(APIs.USERS.changePassword, payload, {
    headers: { platform: PLATFORM.GUARDIAN },
  })

// Forgot password — step 1: send OTP to user email.
export const forgotPasswordInitializeApi = (payload) =>
  apiClient.post(APIs.USERS.forgotPasswordInitialize, payload)

// Forgot password — step 2: confirm OTP and submit new password.
// Uses bare axios (not apiClient) because the endpoint requires the short-lived
// reset token returned by step 1, NOT the persistent accessToken from localStorage.
// `platform: MDG_GUARDIAN` is sent explicitly because bare axios bypasses the
// apiClient interceptor that would otherwise inject the `Platform` header — the
// other auth endpoints in this file all hardcode it for the same reason.
// The reset token is sent as a raw token in the Authorization header (no
// `Bearer ` prefix) per the backend's expectation.
export const forgotPasswordConfirmApi = (payload, resetToken) =>
  axios.put(APIs.USERS.forgotPasswordConfirmation, payload, {
    headers: {
      'Content-Type': 'application/json',
      platform: PLATFORM.GUARDIAN,
      Authorization: resetToken,
    },
  })

export const resetPasswordApi = (payload) =>
  apiClient.put(APIs.USERS.resetPassword, payload, {
    headers: { platform: PLATFORM.GUARDIAN },
  })
